
const wpgq_endpoint = "https://towershibuya.jp/wp/tpiKmoNNxTiQEySJ";
export {wpgq_endpoint}
